import React from 'react';

const SIZES = {
  sm: { box: 40, radius: 'var(--radius-sm)', font: 18 },
  md: { box: 52, radius: 'var(--radius-md)', font: 20 },
  lg: { box: 60, radius: 'var(--radius-lg)', font: 24 },
};

const VARIANTS = {
  solid: { background: 'var(--accent)', color: 'var(--accent-contrast)', border: '1.5px solid transparent' },
  soft:  { background: 'var(--accent-soft)', color: 'var(--text-accent)', border: '1.5px solid transparent' },
  outline: { background: 'var(--surface-raised)', color: 'var(--text-primary)', border: '1.5px solid var(--border-strong)' },
  ghost: { background: 'transparent', color: 'var(--text-secondary)', border: '1.5px solid transparent' },
};

export function IconButton({
  children, label, variant = 'ghost', size = 'md',
  disabled = false, onClick, style = {}, ...rest
}) {
  const s = SIZES[size] || SIZES.md;
  const v = VARIANTS[variant] || VARIANTS.ghost;
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: s.box, height: s.box, minWidth: s.box, fontSize: s.font,
        borderRadius: s.radius, cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.45 : 1, lineHeight: 1,
        transition: 'transform var(--dur-fast) var(--ease-standard), background var(--dur-fast)',
        WebkitTapHighlightColor: 'transparent',
        ...v, ...style,
      }}
      onMouseDown={(e) => { if (!disabled) e.currentTarget.style.transform = 'scale(0.92)'; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      {...rest}
    >
      {children}
    </button>
  );
}
